import { Link, useLocation } from "react-router-dom";
import Logo from "./Logo";
import { useAuth } from "../contexts/AuthContext";
import { LayoutDashboard, LogOut, ShieldCheck, Menu, X, MailCheck } from "lucide-react";
import { useState } from "react";

export default function Header() {
  const { user, logout } = useAuth();
  const [open, setOpen] = useState(false);
  const loc = useLocation();
  const isAuth = user && typeof user === "object";

  const navLinks = [
    { to: "/#how", label: "How it works" },
    { to: "/#pricing", label: "Pricing" },
    { to: "/blog", label: "Blog" },
    { to: "/#faq", label: "FAQ" },
  ];

  return (
    <header className="bg-white/80 backdrop-blur-xl border-b border-[#E2E8F0] sticky top-0 z-50">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 h-16 flex items-center justify-between">
        <Logo />
        <nav className="hidden md:flex items-center gap-8">
          {navLinks.map(l => (
            <a key={l.to} href={l.to} data-testid={`nav-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
               className="text-sm font-medium text-[#475569] hover:text-[#0F172A] transition-colors">
              {l.label}
            </a>
          ))}
        </nav>
        <div className="hidden md:flex items-center gap-3">
          {isAuth ? (
            <>
              {user.role === "admin" && (
                <Link to="/admin" data-testid="header-admin-link"
                  className="inline-flex items-center gap-2 text-sm font-medium text-[#0F172A] px-3 py-2 rounded-lg hover:bg-[#F8FAFC]">
                  <ShieldCheck className="h-4 w-4 text-[#F26953]"/> Admin
                </Link>
              )}
              <Link to="/dashboard" data-testid="header-dashboard-link"
                className="inline-flex items-center gap-2 text-sm font-medium text-[#0F172A] px-3 py-2 rounded-lg hover:bg-[#F8FAFC]">
                <LayoutDashboard className="h-4 w-4"/> Dashboard
              </Link>
              <Link to="/validations" data-testid="header-validations-link"
                className="inline-flex items-center gap-2 text-sm font-medium text-[#0F172A] px-3 py-2 rounded-lg hover:bg-[#F8FAFC]">
                <MailCheck className="h-4 w-4 text-[#F26953]"/> Validations
              </Link>
              <button onClick={logout} data-testid="header-logout-btn"
                className="inline-flex items-center gap-2 text-sm font-medium text-[#475569] px-3 py-2 rounded-lg hover:bg-[#F8FAFC]">
                <LogOut className="h-4 w-4"/> Sign out
              </button>
            </>
          ) : (
            <>
              <Link to="/login" data-testid="header-login-link"
                className="text-sm font-medium text-[#0F172A] px-4 py-2 rounded-lg hover:bg-[#F8FAFC]">Sign in</Link>
              <Link to="/signup" data-testid="header-signup-link"
                className="bg-[#F26953] text-white text-sm font-semibold px-5 py-2.5 rounded-lg hover:bg-[#D85340] transition-colors shadow-sm">
                Get started
              </Link>
            </>
          )}
        </div>
        <button data-testid="mobile-menu-btn" className="md:hidden p-2" onClick={() => setOpen(!open)}>
          {open ? <X className="h-5 w-5"/> : <Menu className="h-5 w-5"/>}
        </button>
      </div>
      {open && (
        <div className="md:hidden border-t border-[#E2E8F0] bg-white px-6 py-4 space-y-3">
          {navLinks.map(l => (
            <a key={l.to} href={l.to} className="block text-sm font-medium text-[#475569] py-1"
               onClick={() => setOpen(false)}>{l.label}</a>
          ))}
          {isAuth ? (
            <>
              <Link to="/dashboard" className="block text-sm font-semibold text-[#0F172A] py-1" onClick={() => setOpen(false)}>Dashboard</Link>
              <Link to="/validations" data-testid="mobile-validations-link" className="block text-sm font-semibold text-[#0F172A] py-1" onClick={() => setOpen(false)}>Validations</Link>
              {user.role === "admin" && <Link to="/admin" className="block text-sm font-semibold text-[#0F172A] py-1" onClick={() => setOpen(false)}>Admin</Link>}
              <button onClick={logout} className="text-sm text-[#475569] py-1">Sign out</button>
            </>
          ) : (
            <>
              <Link to="/login" className="block text-sm py-1">Sign in</Link>
              <Link to="/signup" className="block text-sm font-semibold text-[#F26953] py-1">Get started</Link>
            </>
          )}
          <span className="text-xs text-slate-400">{loc.pathname}</span>
        </div>
      )}
    </header>
  );
}
